import gtm from '@/utils/gtm';
import { useRouter } from 'next/router';
import { textLangCommon } from '../textLangCommon';
import WinCommon from '../WinCommon';
import './index.scss';
import { textLang1 } from './textLang';
export default function WinDeductPoints({
    callback,
    okCallback,
    gainConfig,
    currentCheckData,
    activeData,
}: {
    callback: any;
    okCallback: any;
    gainConfig: any;
    currentCheckData?: any;
    activeData?: any;
}) {
    const { locale = 'us' } = useRouter();
    const TextA = textLang1[locale] || textLang1['us'];
    const TextB = textLangCommon[locale] || textLangCommon['us'];
    const descA = `${TextA.descPoints1}${gainConfig}${TextA.descPoints2}`;
    const btnDataLayer = {
        event: 'uaEvent',
        event_name: 'check_in_success',
        position: `${currentCheckData.month}/${currentCheckData.day}_Deduct EcoCredits`,
        button_name: TextB.btn1,
        list_name: activeData.campaignName,
    };
    const okCallback2 = () => {
        if (okCallback) {
            okCallback();
        }
        gtm.push(btnDataLayer);
    };

    return <WinCommon callback={callback} title={TextB.title} desc={descA} btnText={TextB.btn1} okCallback={okCallback2} />;
}
